import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { CustomerAddressesArrayModel, CustomerAddressesModel, CustomerAddressModel } from 'src/models/customer/addressesModel';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/customeraddresses';

export const CustomerAddresseServicess = {
  getAllData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getAllCustomerAddressesById?customerId=${dataId}`
      );
      return response.data as CustomerAddressesModel;
    } catch (error) {
      throw error;
    }
  },

  getAddressData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?customerAddressId=${dataId}`
      );
      return response.data as CustomerAddressModel;
    } catch (error) {
      throw error;
    }
  },  

  addData: async (dataToAdd: any) => {
    const reModel = {
      customerId: dataToAdd.customerId,
      name: dataToAdd.customerName,
      addressLine1: dataToAdd.addresses.addressLine1,
      addressLine2: dataToAdd.addresses.addressLine2,
      contactNumber1: dataToAdd.addresses.contactNumber1,
      contactNumber2: dataToAdd.addresses.contactNumber2,
      mobileNumber: dataToAdd.addresses.mobileNumber,
      landMark: dataToAdd.addresses.landMark,
      geoLocation: dataToAdd.addresses.geoLocation,
      cityId: dataToAdd.addresses.cityID,
      areaId: dataToAdd.addresses.areaID,
      isActive: dataToAdd.addresses.isActive,
      customerAddressTypeId: dataToAdd.addresses.customerAddressTypeId
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, reModel);
      enqueueSnackbar(`Address Added Successfully`, {
        variant: 'success'
      });
      return response.data as CustomerAddressesModel[];
    } catch (error) {
      throw error;
    }
  },

  editData: async (dataToUpdate: any) => {
    const reModel = {
      id: dataToUpdate.addressId,
      name: dataToUpdate.name,
      addressLine1: dataToUpdate.addressLine1,
      addressLine2: dataToUpdate.addressLine2,
      contactNumber1: dataToUpdate.contactNumber1,
      contactNumber2: dataToUpdate.contactNumber2,
      mobileNumber: dataToUpdate.mobileNumber,
      landMark: dataToUpdate.landMark,
      geoLocation: dataToUpdate.geoLocation,
      cityId: dataToUpdate.cityID,
      areaId: dataToUpdate.areaID,
      isActive: dataToUpdate.isActive,
      customerAddressTypeId: dataToUpdate.customerAddressTypeId
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`Address Edited Successfully`, {
        variant: 'success'
      });
      // const dataToUpdateBack = {
      //   ...respons.data,
      //   unitOfMeasures: {
      //     id: dataToUpdate.UnitOfMeasure.Id,
      //     shortName: dataToUpdate.UnitOfMeasure.Name
      //   }
      // };
      // return dataToUpdateBack as CustomerAddressesModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (deleteId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`Address Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as CustomerAddressesModel[];
    } catch (error) {
      throw error;
    }
  }
};
